import CustomCheckoutReviewAndSubmitReducer from "@preferredMedical/Store/Pages/CheckoutReviewAndSubmit/CustomCheckoutReviewAndSubmitReducer";
import InvoiceHistoryReducer from "@preferredMedical/Store/Pages/InvoiceHistory/InvoiceHistoryReducer";
import OrderHistoryReducer from "@preferredMedical/Store/Pages/OrderHistory/OrderHistoryReducer";
import ProductPromotionsReducer from "@preferredMedical/Store/Pages/ProductPromotions/ProductPromotionsReducer";
import { combineReducers } from "redux";

const reducers = {
    checkoutReviewAndSubmit: CustomCheckoutReviewAndSubmitReducer,
    orderHistory: OrderHistoryReducer,
    invoiceHistory: InvoiceHistoryReducer,
    productPromotions: ProductPromotionsReducer,
};

export type CustomReducers = typeof reducers;

const customReducer = combineReducers(reducers as any);

export default customReducer;
